import {connectToStores} from 'epic-alt-utils';
import PropTypes from 'prop-types';
import React from 'react';

import CtaFooter from '../../components/chapter2/s7/CtaFooter';
import MetaTags from '../../components/common/MetaTags';
import Carousel from '../../components/home/v2/Carousel';
import HomeBlog from '../../components/home/v2/HomeBlog';
import CmsLoadScreen from '../../components/loadScreen/CmsLoadScreen';
import {CmsStore, HeaderStore, LoginStore} from '../../stores';
import {fetchCmsData} from '../../utils/CmsStoreUtils';

/**
 * HomePage View.
 */
const cmsUrlPattern = 'home';

const HomeView = (props) => {
  const {mobile, tablet, android, cmsStore} = props;

  const showLoading =
    !cmsStore?.pages[cmsUrlPattern] ||
    !cmsStore.pages[cmsUrlPattern].data ||
    cmsStore.pages[cmsUrlPattern].loading;
  if (showLoading) return <CmsLoadScreen page={cmsStore?.pages[cmsUrlPattern]} />;

  const {
    carousel,
    bottomCard,
    postsPerPage,
    lightTheme,
    pageClasses,
    meta = {},
  } = cmsStore.pages[cmsUrlPattern].data;
  const {slides} = carousel;
  const className = lightTheme ? 'light-theme' : null;

  return (
    <div id="homePage" className={`${className} ${pageClasses}`}>
      <MetaTags meta={meta} />
      <Carousel slides={slides} mobile={mobile} tablet={tablet} isAndroid={android} />
      <HomeBlog
        {...props}
        enableAutoShortDescription={true}
        mobilePostNum={2}
        postsPerPage={postsPerPage}
      />
      <CtaFooter data={bottomCard} mobile={mobile} className="home" />
    </div>
  );
};

HomeView.getStores = () => {
  return [LoginStore, HeaderStore, CmsStore];
};

HomeView.getInitialActions = () => {
  return [fetchCmsData(cmsUrlPattern)];
};

HomeView.getPropsFromStores = () => {
  return {
    loginStore: LoginStore.getState(),
    cmsStore: CmsStore.getState(),
    mobile: HeaderStore.getState().mobile(),
    tablet: HeaderStore.getState().tablet(),
    android: HeaderStore.getState().android(),
  };
};

HomeView.propTypes = {
  loginStore: PropTypes.object,
  mobile: PropTypes.bool,
  tablet: PropTypes.bool,
  android: PropTypes.bool,
  cmsStore: PropTypes.object,
};

export default connectToStores(HomeView);
